<template>
  <section>
    <transition name="slide">
      <div v-if="mapVisible">
        <Map id="map" ref="map" @selectedStop="updateSelected" />
        <div id="info-tab" @mousedown="toggleMap">
          <button v-if="selected !== -1" class="content-button">
            <i class="chevron-up"></i>
          </button>
          <div v-if="selected !== -1">
            <article class="stop-info">
              <div class="stop-content">
                <h3 class="title is-5">
                  {{ this.stopData[this.selected].Name }}
                </h3>
                <p>
                  <br />
                  {{ this.stopData[this.selected].QuickSummary }}
                </p>
              </div>
              <figure class="stop-image">
                <img :src="getImage()" />
              </figure>
            </article>
          </div>
          <div v-else class="content has-text-centered">
            <p>
              Click on a location for more information. If you are on campus you
              can track your location by clicking the pin icon on the top right
              of the map.
            </p>
          </div>
        </div>
      </div>
      <div v-if="!mapVisible">
        <LocationContent
          @close-content="toggleMap"
          :name="this.stopData[this.selected].Name"
        />
      </div>
    </transition>
  </section>
</template>

<script>
import Map from "@/components/Map.vue";
import LocationContent from "@/components/LocationContent.vue";
import axios from "axios";

export default {
  name: "Home",
  components: { Map, LocationContent },
  asyncComputed: {
    stopData: {
      async get() {
        return await axios
          .get(`/data/${this.language}/stops.json`)
          .then(response => response.data);
      },
      default: "Loading..."
    }
  },
  computed: {
    selected() {
      return this.$store.state.selected;
    },
    language() {
      return this.$store.state.language;
    },
    mapVisible() {
      return this.$store.state.mapVisible;
    },
    currentAudio() {
      return this.$store.state.currentAudio;
    },
    playState() {
      return this.$store.state.audioPlayState;
    }
  },
  methods: {
    toggleMap() {
      if (this.selected === -1) {
        this.$router.push("/sites");
      } else {
        this.$store.commit("setMapVisibility", !this.mapVisible);
        if (!this.mapVisible) {
          this.$store.commit("setFocus", false);
        }
      }
      if (this.playState) {
        this.$store.commit("setAudioPlayState", false);
        this.currentAudio.pause();
      }
    },
    updateSelected(selected) {
      this.$store.commit("setSelected", selected);
    },
    getImage() {
      return require(`@/assets/stopicons/${this.selected}.jpg`);
    }
  }
};
</script>

<style lang="scss" scoped>
#map {
  height: calc(75vh - 3.25rem);
}

#info-tab {
  position: relative;
  top: -3.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  left: -50%;
  width: 200%;
  border-radius: 50% 50% 0 0;
  padding-top: 1.5vh;
  background: $red-gradient;
  height: 25vh;

  div {
    padding: 0.25rem;
    width: 100vw;
  }
}

.slide-enter-active {
  animation: slide 10s;
}

.slide-leave-active {
  animation: slide 10s reverse;
}

@keyframes slide {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100vh);
  }
}

.stop-info {
  display: flex;
  align-items: center;
  margin: 1rem 0.5rem;
  height: 15vh;

  .stop-content {
    font-size: x-small;
    color: white;
    word-wrap: break-word;
    margin: 0 0.5rem;
    strong {
      color: white;
    }
  }

  .stop-image {
    img {
      height: 16vh;
      width: auto;
      object-fit: cover;
      object-position: center center;
      box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
    }
  }
}

.content {
  color: white;
  p {
    padding: 0 5vw;
  }
}
</style>
